import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';
import clsx from 'clsx';

const useStyles = createUseStyles(() => ({
  root: {
    position: 'relative',
  },
  container: {
    position: 'relative',
    backgroundColor: '#fefefe',
    height: 50,
    width: '100%',
    borderRadius: 10,
    padding: '0px 20px',
    zIndex: 11,
    marginBottom: '3vh',
    justifyContent: 'space-between',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    '&$extended': {
      height: ({ xl }) => `${xl ? 70 : 50}vh`,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    },
    '& h4': {
      margin: 0,
    },
  },
  extended: {},
  alignHorizontal: {
    display: 'flex',
    alignItems: 'center',
  },
  menu: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 10,
    transition:
      'width 0.5s cubic-bezier(0.31, 0.71, 0.17, 0.96), height 0.5s cubic-bezier(0.31, 0.71, 0.17, 0.96), padding 0.5s cubic-bezier(0.31, 0.71, 0.17, 0.96)',
    overflow: 'hidden',
    '& > *:first-child': {
      marginTop: 70,
    },
  },
}));

interface Props {
  appViewNavExtended?: boolean;
  toggleAppViewNavExtended?: () => void;
  actionButton?: any;
  title?: string;
  goBack?: () => void;
  xl?: boolean;
  children?: any;
}

const SubNavBar: FC<Props> = ({
  appViewNavExtended,
  toggleAppViewNavExtended,
  actionButton,
  title,
  goBack,
  xl,
  children,
}) => {
  const classes = useStyles({ xl });

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.container, classes.alignHorizontal, {
          ['extended']: appViewNavExtended,
        })}
      >
        <button onClick={goBack} type='button' className='btn btn-sm btn-outline-success'>
          <span className='icon icon-back' />
        </button>

        <h4>{title}</h4>
        <div className='alignHorizontal'>
          {actionButton ? (
            actionButton
          ) : (
            <button onClick={toggleAppViewNavExtended} type='button' className='btn btn-sm btn-outline-success'>
              <span className={'icon icon-' + (appViewNavExtended ? 'cross ' : 'add-to-list ')}>Actions</span>
            </button>
          )}
        </div>
      </div>

      <div
        className={clsx(classes.container, classes.menu, {
          [classes.extended]: appViewNavExtended,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default SubNavBar;
